import { registerFeature } from "lib/features"
import { FEATURE_FLAG_TAILORED_SCHEDULE_AUDITING } from "./server/feature-flag-tailored-schedule-auditing.mjs"
import { ScheduleExtension } from "routes/schedule/extendedSchedule"
import { and } from "lib/logic"
import { TailoredAuditing } from "./tailored-auditing"
import { AuditEntryBox, AuditEntryBoxAbove, ScheduleItemWrapper, ScheduleTreeBar } from "slot-definitions"
import { replaceAllWith } from "lib/@components/slot/replace-all-with"
import { JustificationReason } from "./justification-reason"
import { TailoredChanges } from "./tailored-changes"
import { AuditDownloadExtra } from "routes/audit/component/top-bar"
import { addTailoringAuditData } from "./lib/add-tailoring-audit-data"
import { TAILORING_AUDIT_TYPE } from "./server/tailoring-audit-constants.mjs"
import { isInRegime, notSharing } from "routes/facilities/lib/when-parent-item"
import { TailoredActivity } from "./tailored-activity"
import { isTailoredScheduleAuditingEnabled } from "./lib/is-tailored-schedule-auditing-enabled"
import { isTailoringEvent } from "./lib/is-tailoring-event"
import { TailoredReference } from "./tailored-reference"
import { RemoveFromGroup, TaskTailorChange } from "event-definitions"
import { RemoveAllCustomisations } from "../../extension-edit"
import { removeTailoredAuditsFromSchedule } from "./lib/remove-tailored-audits-from-schedule"
import { setTaskTailored } from "./lib/set-task-tailored"

registerFeature({
    numericalId: 18,
    name: "Tailored Schedule Auditing",
    id: FEATURE_FLAG_TAILORED_SCHEDULE_AUDITING,
    description: `Enables the auditing of tailoring performed on regime schedules and allows the user to add a justification.`,
    readyForProduction: true,
})

ScheduleExtension.plug(
    <TailoredAuditing if={and(isTailoredScheduleAuditingEnabled, (c) => !!c.editExtension, notSharing)} />
)

ScheduleTreeBar.plug(
    <TailoredActivity priority={250} if={and(isTailoredScheduleAuditingEnabled, (c) => isInRegime(c), notSharing)} />
)

ScheduleItemWrapper.plug(
    <TailoredReference if={and(isTailoredScheduleAuditingEnabled, (c) => isInRegime(c), notSharing)} />
)

AuditEntryBoxAbove(TAILORING_AUDIT_TYPE).plug(<TailoredChanges if={isTailoredScheduleAuditingEnabled} />)

AuditEntryBox(TAILORING_AUDIT_TYPE).plug(
    replaceAllWith(
        <JustificationReason
            if={and(isTailoredScheduleAuditingEnabled, (c) => isTailoringEvent(c.auditProps?.payload))}
        />
    )
)

AuditDownloadExtra(TAILORING_AUDIT_TYPE).handle(({ row, data }) => addTailoringAuditData(row, data))

RemoveFromGroup.handleOnce(removeTailoredAuditsFromSchedule)

RemoveAllCustomisations.handleOnce(removeTailoredAuditsFromSchedule)

TaskTailorChange.handleOnce(setTaskTailored)
